import { Component, OnInit, OnDestroy } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { ReportGridService } from "../services/report-grid.service";

@Component({
  selector: "app-cancelled-report",
  templateUrl: "./cancelled-report.component.html",
})
export class CancelledReportComponent implements OnInit, OnDestroy {
  rowsData: any[] = [];
  columnsData: any = [];
  row: any = {};
  destroyComponent: any = {};
  totalItems = 0;
  maxSize = 10;
  maxSizeItem = 10;
  pageOrder: any = {};
  currentPage = 1;
  page: number;
  searchPatient = "";

  errorMessage = "";
  constructor(
    private api: AppService,
    private supportService: SupportService,
    private router: Router,
    private datepiper: DatePipe,
    private reportGrid: ReportGridService
  ) {}
  userType: any;
  startDate: any;
  fromMessageCentre: any;
  selectedtab: any;
  date: Date;
  newDate: Date;
  cancelPrintList: any;

  checklength(value) {
    return this.reportGrid.checklength(value);
  }

  ngOnInit() {
    this.newDate = new Date();
    let date = new Date();
    this.fromMessageCentre = sessionStorage.getItem("fromMessagecentre");
    if (this.fromMessageCentre === "true") {
      this.supportService.headerSubLittle.next("Home");
    }
    this.userType = sessionStorage.getItem("usertype");
    if (sessionStorage.getItem("currentTab") != null) {
      this.selectedtab = sessionStorage.getItem("currentTab");
    }
    if (this.selectedtab === "today") {
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    if (this.selectedtab === "tomorrow") {
      date = new Date();
      date.setDate(date.getDate() + 1);
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    if (this.selectedtab === "yesterday") {
      date.setDate(date.getDate() - 1);
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    if (this.selectedtab === "dayafter") {
      date.setDate(date.getDate() + 2);
      this.startDate = this.reportGrid.formatYmd(this, date);
    }
    this.getRowsData();
    this.generate();
    this.getColumnOrder();
    if (this.fromMessageCentre === "false") {
      this.getCancelPirntList();
    }
  }

  private getRowsData() {
    this.rowsData = [
      {
        title: "First Name",
        sorting: true,
        name: "patientFirstName",
        dateFitler: false,
      },
      {
        title: "Last Name",
        sorting: true,
        name: "patientLastName",
        dateFitler: false,
      },
      {
        title: "Date Booked",
        sorting: true,
        name: "createdOn",
        dateFitler: true,
      },
      {
        title: "Date of Service",
        sorting: true,
        name: "scheduledOnStr",
        dateFitler: true,
      },
      {
        title: "Patient Type",
        sorting: true,
        name: "patientType",
        dateFitler: false,
      },
      {
        title: "Time Recorded Cancelled",
        sorting: false,
        name: "canceledOn",
        dateFitler: false,
      },
      {
        title: "Online or Called",
        sorting: false,
        name: "patientType",
        dateFitler: false,
      },
      {
        title: "By whom",
        sorting: false,
        name: "canceledBy",
        dateFitler: false,
      },
      {
        title: "Reason",
        sorting: false,
        name: "cancelReason",
        dateFitler: false,
      },
    ];
    this.row = {
      param1: "patientFirstName",
      param2: "patientLastName",
      param3: "createdOn",
      param4: "scheduledOnStr",
      param5: "patientType",
      param6: "canceledOn",
      param7: "patientType",
      param8: "canceledBy",
      param9: "cancelReason",
    };
    this.pageOrder = {
      type: "canceled",
      pageNumber: 1,
      pageRecord: this.maxSizeItem,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "canceledOn",
      sortType: "desc",
      search: "",
    };
  }

  getCancelPirntList() {
    const pageOrder = this.clearCacheItem("savePdf");
    const param = pageOrder;
    param["offsetmin"] = new Date().getTimezoneOffset();
    this.api.getScheduleByType(param).subscribe((res: any) => {
      this.cancelPrintList = [];
      if (res && res.entity) {
        this.cancelPrintList = res.entity;
      }
    });
  }

  private getColumnData(param?, blur?) {
    if (sessionStorage.getItem("fromMessagecentre") === "true") {
      let data;
      if (sessionStorage.getItem("canceledBy") === "Patient") {
        data = {
          pageNumber: this.currentPage,
          pageRecord: this.maxSizeItem,
          search: this.searchPatient,
          fromDate: this.startDate,
          toDate: this.startDate,
          type: "patientcancelled",
          sortColumn: this.pageOrder["sortColumn"],
          sortType: this.pageOrder["sortType"],
        };
      }
      if (sessionStorage.getItem("canceledBy") === "Ic") {
        data = {
          pageNumber: this.currentPage,
          pageRecord: this.maxSizeItem,
          search: this.searchPatient,
          fromDate: this.startDate,
          toDate: this.startDate,
          type: "iccancelled",
          sortColumn: this.pageOrder["sortColumn"],
          sortType: this.pageOrder["sortType"],
        };
      }

      this.api.getgriddata(data).subscribe(
        (res: any) => {
          this.columnsData = [];
          this.columnsData = [];
          if (blur && blur === "blur") {
            this.currentPage = 1;
          }
          if (res && res.entity) {
            this.totalItems = res["count"];
            res.entity.forEach((obj) => {
              if (obj && obj["canceled"]) {
                const param = this.getParamData(obj);
                this.columnsData.push(param);
              }
            });
          }
        },
        (err) => {
          if (err.error.error === "invalid_token") {
            this.api.sessionOut(err);
          }
        }
      );
    } else {
      this.api.getScheduleByType(param).subscribe(
        (res: any) => {
          this.columnsData = [];
          if (blur && blur === "blur") {
            this.currentPage = 1;
          }
          if (res && res.entity) {
            this.totalItems = res["count"];
            res.entity.forEach((obj1) => {
              if (obj1 && obj1["canceled"]) {
                const param = this.getParamData(obj1);
                this.columnsData.push(param);
              }
            });
          }
        },
        (err1) => {
          if (err1.error.error === "invalid_token") {
            this.api.sessionOut(err1);
          }
        }
      );
    }
  }

  navigateToMessagecenter() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "message-center",
    ]);
  }

  private getParamData(obj) {
    const param: any = this.reportGrid.buildRowParams(this, obj);

    param.param7 = param.param7 === "IC" ? "Called" : "Online";
    param.param5 = param.param5 === "IC" ? "IC" : "SchedMed";
    if (param.param3) {
      param.param3 = this.convertutctolocal(param.param3, "");
    }
    if (param.param6) {
      param.param6 = this.convertutctolocal(param.param6, "time");
    }
    return param;
  }
  private getColumnOrder() {
    this.reportGrid.getColumnOrder(this);
  }
  ngOnDestroy() {
    this.reportGrid.ngOnDestroy(this);
  }
  pageChanged(event) {
    this.reportGrid.pageChanged(this, event);
  }
  generate() {
    this.reportGrid.generate(this);
  }
  savePdf(ev) {
    this.reportGrid.savePdfWithSaveAs(this, ev);
  }
  private clearCacheItem(pdf?) {
    return {
      type: "canceled",
      pageNumber: 0,
      pageRecord: 0,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "canceledOn",
      sortType: "desc",
      search: this.pageOrder["search"] ? this.pageOrder["search"] : "",
    };
  }
  blurOnChange(ev) {
    this.reportGrid.blurOnChange(this, ev);
    this.getCancelPirntList();
  }

  convertutctolocal(value, type) {
    return this.reportGrid.convertutctolocal(this.datepiper, value, type);
  }
}
